document.addEventListener("DOMContentLoaded", function() {
    const shieldsSections = document.querySelectorAll(".shields");

    shieldsSections.forEach(shieldsSection => {
        const switchers = shieldsSection.querySelectorAll(".shields__switcher");
        const prices = shieldsSection.querySelectorAll(".shields__shield-price");

        switchers.forEach(switcher => {
            switcher.addEventListener("click", function() {
                // Usunięcie klasy 'shields__switcher--active' z wszystkich switcherów w ramach tej sekcji
                switchers.forEach(sw => sw.classList.remove("shields__switcher--active"));
                
                // Dodanie klasy 'shields__switcher--active' do klikniętego switchera
                switcher.classList.add("shields__switcher--active");

                // Sprawdzenie, który switcher został kliknięty
                if (switcher.classList.contains("shields__switcher--monthly")) {
                    // Ustawienie ceny miesięcznej dla wszystkich cen w ramach tej sekcji
                    prices.forEach(price => {
                        const monthlyPrice = price.getAttribute("data-monthly");
                        price.textContent = monthlyPrice;
                    });
                } else if (switcher.classList.contains("shields__switcher--yearly")) {
                    // Ustawienie ceny rocznej dla wszystkich cen w ramach tej sekcji
                    prices.forEach(price => {
                        const yearlyPrice = price.getAttribute("data-yearly");
                        price.textContent = yearlyPrice;
                    });
                }
            });
        });
    });
});
